import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import usePortalPopper from '../../../Hooks/UsePortalPopper';
import { useState, useEffect } from 'react';
import contextMenuManager from '../../../Utility/ContextMenuManager';
import ContextMenu from './ContextMenu';
export default function ContextMenuContainer() {
    const [contextMenu, setContextMenu] = useState(null);
    useEffect(() => {
        contextMenuManager.registerSetState(setContextMenu);
    }, []);
    if (!contextMenu) {
        return null;
    }
    return _jsx(VirtualContextMenu, { ...contextMenu });
}
function VirtualContextMenu(props) {
    const { items, className, onCancelled, coords } = props;
    const onClose = () => {
        contextMenuManager.hideContextMenu();
        setIsMenuVisible(false);
    };
    const [portal, setIsMenuVisible] = usePortalPopper({
        coords,
        children: _jsx(ContextMenu, { items: items, className: className, close: onClose }),
        isVisible: true,
        hideOnOutsideClick: true,
        outsideClickCallback: () => {
            onCancelled?.();
            contextMenuManager.hideContextMenu();
        },
        styles: {
            // allows the menu to be positioned on top of a modal if the context menu is in a modal
            zIndex: 700,
        },
        updateOnDomMutations: true,
    });
    return _jsx(_Fragment, { children: portal });
}
//# sourceMappingURL=ContextMenuContainer.js.map